var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoElement",staticStyle:{"width":"100%"},attrs:{"controls":_vm.isControls}})])
}
var staticRenderFns = []

export { render, staticRenderFns }